var _defs, _path, _path2, _circle, _rect, _path3, _rect2, _path4, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "box",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7FD8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B9AA0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16a17 17 0 0 1 24 0",
    fill: "none",
    stroke: "#2B9AA0",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21a10 10 0 0 1 14 0",
    fill: "none",
    stroke: "#2B9AA0",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25.5,
    r: 2.5,
    fill: "#2B9AA0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 48,
    height: 27,
    rx: 8,
    fill: "url(#box)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36h26",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 42,
    width: 22,
    height: 9,
    rx: 3,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 46.5h3M22 46.5h3M27 46.5h3M32 46.5h1",
    stroke: "#2B9AA0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46.5,
    r: 5,
    fill: "#22C55E",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceStatus);
export default __webpack_public_path__ + "static/media/deviceStatus.4fbdac16518cf05def43df57c0d43d3e.svg";
export { ForwardRef as ReactComponent };